function base64ToArrayBuffer(base64) {
    base64 = base64.replace(/\s/g, '');
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}

function downloadPDFData(pdfData) {
    if (pdfData) {
        var data = base64ToArrayBuffer(pdfData);
        var blob = new Blob([data], {
            type: 'application/pdf'
        });

        var today = new Date();
        var date = today.getDate() + "_" + today.getMonth() + "_" + today.getFullYear() + "_" + today.getHours() + "_" + today.getMinutes() + "_" + today.getSeconds();
        var isIE = /*@cc_on!@*/false || !!document.documentMode;
        if (isIE) {
            if (confirm("Confirm Download!") == true) {
                if (navigator.msSaveOrOpenBlob) {
                    navigator.msSaveOrOpenBlob(blob, 'rbl_statement_' + date + '.pdf');
                } else {
                    var a = document.createElement('a');
                    a.href = window.URL.createObjectURL(blob);;
                    a.style = "visibility:hidden";
                    a.download = 'rbl_statement_' + date + '.pdf';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }
            }
        } else {
            var a = document.createElement('a');
            a.href = window.URL.createObjectURL(blob);;
            a.style = "visibility:hidden";
            a.download = 'rbl_statement_' + date + '.pdf';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }

    }
}

export {downloadPDFData};